// Shared by the axios client (api.ts) and fetch-based streaming (chatStream.ts).

export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api'

/**
 * Log the user out when the API says the session is gone (401) or access was
 * revoked (403). Shared by the axios client and fetch-based streaming requests.
 */
export function handleAuthFailure(status: number | undefined, data: any, url?: string): void {
  const serverError = data?.error ?? ''
  const errorCode = data?.error_code ?? ''
  const isLoginRequest = url?.endsWith('/login')
  const isUnauthenticated = status === 401 && !isLoginRequest
  const isAccessRevoked =
    status === 403 &&
    (/has been disabled/i.test(String(serverError)) || errorCode === 'organization_access_expired')

  if (isUnauthenticated || isAccessRevoked) {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('user')
    window.location.href = '/login'
  }
}
